import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ShellComponent } from './shell/shell.component';
import { AuthenticationService } from './authentication/authentication.service';
import { AuthenticationGuard } from './authentication/authentication.guard';
import { SpHeaderComponent } from '../components/sp-header/sp-header.component';
import { SpTabbarComponent } from '../components/sp-tabbar/sp-tabbar.component';
import { SpSidenavComponent } from '../components/sp-sidenav/sp-sidenav.component';
import { JwtInterceptor } from './interceptor/interceptor.service';
import { FooterComponent } from '../components/footer/footer.component';
import { DragDropDirective } from '../directive/drag-drop.directive';


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule,
    NgbModule,
    RouterModule
  ],
  exports: [DragDropDirective ],
  declarations: [
    SpHeaderComponent,
    SpSidenavComponent,
    SpTabbarComponent,
    ShellComponent,
    FooterComponent,
    DragDropDirective

  ],
  providers: [
    AuthenticationService,
    AuthenticationGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    }
  ]
})
export class CoreModule {

  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    // Import guard
    if (parentModule) {
      throw new Error(`${parentModule} has already been loaded. Import Core module in the AppModule only.`);
    }
  }

}
